import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M6.87744 8.87744H10.8774"
        stroke="#F59C53"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7108 9.87744H19.1082C17.3239 9.87744 15.8774 11.2206 15.8774 12.8774C15.8774 14.5343 17.3239 15.8774 19.1082 15.8774H21.7108C21.7941 15.8774 21.8358 15.8774 21.871 15.8753C22.4102 15.8425 22.8398 15.4436 22.8751 14.9428C22.8774 14.9102 22.8774 14.8715 22.8774 14.7941V10.9608C22.8774 10.8834 22.8774 10.8447 22.8751 10.812C22.8398 10.3113 22.4102 9.9124 21.871 9.87958C21.8358 9.87744 21.7941 9.87744 21.7108 9.87744Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M21.8425 9.87744C21.7647 8.00514 21.514 6.85719 20.7059 6.04901C19.5343 4.87744 17.6487 4.87744 13.8774 4.87744L10.8774 4.87744C7.1062 4.87744 5.22059 4.87744 4.04901 6.04901C2.87744 7.22059 2.87744 9.10621 2.87744 12.8774C2.87744 16.6487 2.87744 18.5343 4.04901 19.7059C5.22059 20.8774 7.10621 20.8774 10.8774 20.8774H13.8774C17.6487 20.8774 19.5343 20.8774 20.7059 19.7059C21.514 18.8977 21.7647 17.7497 21.8425 15.8774"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M18.8687 12.8774H18.8777"
        stroke="#F59C53"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M6.87756 8.87744H10.8776"
        stroke="white"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7109 9.87744H19.1083C17.324 9.87744 15.8776 11.2206 15.8776 12.8774C15.8776 14.5343 17.324 15.8774 19.1083 15.8774H21.7109C21.7942 15.8774 21.8359 15.8774 21.8711 15.8753C22.4103 15.8425 22.8399 15.4436 22.8753 14.9428C22.8776 14.9102 22.8776 14.8715 22.8776 14.7941V10.9608C22.8776 10.8834 22.8776 10.8447 22.8753 10.812C22.8399 10.3113 22.4103 9.9124 21.8711 9.87958C21.8359 9.87744 21.7942 9.87744 21.7109 9.87744Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M21.8426 9.87744C21.7648 8.00514 21.5142 6.85719 20.706 6.04901C19.5344 4.87744 17.6488 4.87744 13.8776 4.87744L10.8776 4.87744C7.10633 4.87744 5.22071 4.87744 4.04914 6.04901C2.87756 7.22059 2.87756 9.10621 2.87756 12.8774C2.87756 16.6487 2.87756 18.5343 4.04914 19.7059C5.22071 20.8774 7.10633 20.8774 10.8776 20.8774H13.8776C17.6488 20.8774 19.5344 20.8774 20.706 19.7059C21.5142 18.8977 21.7648 17.7497 21.8426 15.8774"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M18.8688 12.8774H18.8778"
        stroke="white"
        strokeOpacity="0.5"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Icon;
